import { domainUtils } from '@wix/santa-editor-utils';

import type { DSRead } from 'types/documentServices';

const getSiteProtocol = (state: AnyFixMe, dsRead: DSRead) => {
  // TODO: replace with dsRead.generalInfo.getPublicUrl();
  // @ts-expect-error
  if (dsRead.generalInfo.isHttpsEnabled()) {
    return 'https';
  }
  return 'http';
};

/**
 * This function is a temporary replacement function for "isDomainConnected",
 * since current implementation is wrong, and there are some cases that we get wrong value.
 * Relevant slack thread:
 * https://wix.slack.com/archives/C022YD75A0J/p1621941716001400
 *
 * Next implementation would go directly to user-domains API and have reliable answer for isDomainConnected.
 * @param dsRead
 */
const isDomainConnected = (dsRead: DSRead): boolean => {
  if (!dsRead?.generalInfo) {
    return false;
  }

  const publicUrl = dsRead.generalInfo.getPublicUrl();

  return domainUtils.isDomainConnected(
    dsRead.generalInfo?.urlFormat,
    publicUrl,
  );
};

// TODO: get rid of state since it's unused
const getFreeDomainPrefix = (state: AnyFixMe, dsRead: DSRead) => {
  const publicUrl = dsRead.generalInfo.getPublicUrl();
  const { origin } = new URL(publicUrl);
  return `${origin}/`;
};

export { getSiteProtocol, isDomainConnected, getFreeDomainPrefix };
